import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Paper,
  Tooltip,
  InputAdornment,
  Collapse,
  Checkbox,
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ContentCopy as CopyIcon,
  ArrowBack as BackIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  CompareArrows as CompareArrowsIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Check as CheckIcon,
} from '@mui/icons-material';

import axios from 'axios';
// import { useSearch } from './SearchContext';
// import Keyvault from './Keyvault';
import config from "../../env.json"
import SearchIcon from '@mui/icons-material/Search';
import DatabaseMenu from './DatabaseMenu';
import { useSearch } from '../Keyvault/SearchContext';

// import { getVaultSecrets, addSecret, updateSecret, deleteSecret } from '../services/vaultService';
// import Header from '../app/Layout/Header/header';
interface Secret {
  LastUpdated: string;
  id: string;
  name: string;
  value: string;
  type: 'secret' | 'certificate' | 'key';
  parentName: string;
  repoName: string;
}

interface Vault {
  name: string;
  Id: number;
  Client_Id: number;
  ClientRsKeyVault_Nm: string;
  CommonKeyVault_Nm: string;
  value?: string; // for missing secret value
  firstValue?: string; // for different secrets current value
  secondValue?: string; // for different secrets new value
}

interface MigrationState {
  selectedMissing: number[];
  selectedDifferent: number[];
  isMigrating: boolean;
  isExpanded: boolean;
}

interface ComparisonResult {
  missingData: { Id: number, Trn_Id: number, Permissions_Nm: string, OldPermissionDefaut_Val: string, NewPermissionDefaut_Val: string, Action_Typ: string, Active_Flg: "Y" | "N" }[];
  differenceData: { Id: number, Trn_Id: number, Permissions_Nm: string, OldPermissionDefaut_Val: string, NewPermissionDefaut_Val: string, Action_Typ: string, Active_Flg: "Y" | "N" }[];
}

const TransactionDetail: React.FC = () => {

  console.log("TransactionDetail component rendered");
  const { transactionId } = useParams<{ transactionId: string }>();
  const { vaultName } = useParams<{ vaultName: string }>();
  const { vaultId } = useParams<{ vaultId: string }>();
  const navigate = useNavigate();
  const [secrets, setSecrets] = useState<Secret[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [missingvaults, setMissingVaults] = useState<Vault[]>([]);
  const [newSecret, setNewSecret] = useState<Partial<Secret>>({ name: '', value: '' });
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [pageload, setPageload] = useState<boolean>(false);
  const [viewedSecrets, setViewedSecrets] = useState<Record<string, boolean>>({});
  const { searchText, setSearchText } = useSearch();
  const [comparisonResult, setComparisonResult] = useState<ComparisonResult | null>(null);
  const [changes, setChanges] = useState<Record<number, boolean>>({});



  const [migrationState, setMigrationState] = useState<MigrationState>({
    selectedMissing: [],
    selectedDifferent: [],
    isMigrating: false,
    isExpanded: true
  });

    const fetchComparisons = async () => {
      // console.log("Fetching comparison data for transactionId:", transactionId);  
      if (!transactionId) return;

      try {
        console.log("Fetching comparison data for transactionId:", transactionId);
        setLoading(true);
        // TODO: Replace with actual API call
        // const data = await getVaultSecrets(vaultName);
        // setSecrets(data);

        // Mock data for now
        const response = await axios.get(
          config.REACT_APP_ENV_API_BASE + '/dbMigration/transaction/' + transactionId,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sessionStorage.getItem('login')}`,
            },
          }
        );
        const comparisonData = response?.data?.data;
        console.log('Comparison Data:', comparisonData);
        setComparisonResult(comparisonData);

        setLoading(false);
      } catch (err) {
        setError('Failed to fetch DB Comparison data');
        setLoading(false);
      }
    };

  useEffect(() => {
    fetchComparisons();
  }, []);

  if (!comparisonResult) return null;

  const { missingData, differenceData } = comparisonResult;
  console.log('Comparison Result:', comparisonResult);
  // Mock secret values - replace with actual API call in production
  const getSecretValue = (secretName: string, type: 'current' | 'new') => {
    // In a real implementation, this would make an API call to get the actual secret value
    return type === 'current'
      ? `current-value-for-${secretName}`
      : `new-value-for-${secretName}`;
  };

  const handleMigrateSelected = async () => {
    // if (!comparisonResult) return;

    // const { selectedMissing, selectedDifferent } = migrationState;
    // if (selectedMissing.length === 0 && selectedDifferent.length === 0) {
    //   // setStatusMessage('Please select at least one secret to migrate.');
    //   return;
    // }
    if (Object.keys(changes).length === 0) return;

    setMigrationState(prev => ({ ...prev, isMigrating: true }));

    try {
      const { selectedMissing, selectedDifferent } = migrationState;
      // console.log('Selected Missing IDs:', selectedMissing);
      // console.log('Selected Different IDs:', selectedDifferent);
      // const combinedSelections = [...selectedMissing, ...selectedDifferent];

      const combinedSelections: {setActive: number[], setInactive: number[]} = {setActive: [], setInactive: []};
      Object.entries(changes).forEach(([id, isActive]) => {
        if (isActive) {
          combinedSelections.setActive.push(Number(id));
        } else {
          combinedSelections.setInactive.push(Number(id));
        }
      });
      

      await axios.post(config.REACT_APP_ENV_API_BASE + '/dbMigration/approvePermission',
        {
          permissions: combinedSelections,
          TransactionId: transactionId
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('login')}`,
          },
        });
    } catch (error) {
      console.error('Migration failed:', error);
      // throw new Error('Migration failed');
      // setStatusMessage(error instanceof Error ? error.message : 'Failed to migrate secrets. Please try again.');
    } finally {
      setMigrationState(prev => ({
        ...prev,
        isMigrating: false,
        selectedMissing: [],
        selectedDifferent: []
      }));
      setChanges({});
      fetchComparisons();
    }
  };

  const hasMissing = missingData.length > 0;
  const hasDifferent = differenceData.length > 0;
  const { isExpanded, isMigrating, selectedMissing, selectedDifferent } = migrationState;

  const handleCopyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const toggleViewSecret = (name: string) => {
    console.log("name", name);
    setViewedSecrets((prev) => ({ ...prev, [name]: !prev[name] }));
    console.log(viewedSecrets)
  };


  // Handle checkbox toggle
  const handleCheckboxChange = (id: number, originalStatus: boolean) => {
    setChanges(prev => {
      const newChanges = { ...prev };
      const newStatus = !(prev[id] ?? originalStatus);

      if (newStatus === originalStatus) {
        // if same as API → remove from changes
        delete newChanges[id];
      } else {
        // if different → store only changed value
        newChanges[id] = newStatus;
      }

      return newChanges;
    });
  };


  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" p={3}>
        <Typography color="error">{error}</Typography>
        <Button
          variant="outlined"
          startIcon={<BackIcon />}
          onClick={() => navigate('/Keyvaults')}
          sx={{ mt: 2 }}
        >
          Back to Vaults
        </Button>
      </Box>
    );
  }


  return (
    <Box bgcolor="#f5f5f5" sx={{
      overflowY: 'auto',
      pr: 2,
    }}>
      <DatabaseMenu />
      <Box sx={{ display: 'flex', alignItems: 'center', p: 2, pl: 10 }}>
      <Button
        variant="outlined"
        startIcon={<BackIcon />}
        onClick={() => navigate(-1)} // goes back to previous page
        sx={{
          color: '#734bd1',
          borderColor: '#734bd1',
          '&:hover': {
            backgroundColor: '#f4efff',
            borderColor: '#5e3fb0',
            color: '#5e3fb0',
          },
        }}
      >
        Back
      </Button>
    </Box>
      <Card sx={{ mb: 4, borderLeft: '4px solid', borderColor: 'primary.main', position: "relative", left: "80px", width: "92%" }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            cursor: 'pointer',
            '&:hover': { bgcolor: 'action.hover' }
          }}
          onClick={() => setMigrationState(prev => ({ ...prev, isExpanded: !prev.isExpanded }))}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Database Migration Results
            </Typography>
            <Box sx={{ ml: 2, display: 'flex', gap: 1 }}>
              {hasMissing && (
                <Box sx={{
                  bgcolor: 'warning.light',
                  color: 'warning.contrastText',
                  px: 1,
                  borderRadius: 1,
                  fontSize: '0.75rem',
                  fontWeight: 'bold'
                }}>
                  {missingData.length} Missing
                </Box>
              )}
              {hasDifferent && (
                <Box sx={{
                  bgcolor: 'info.light',
                  color: 'info.contrastText',
                  px: 1,
                  borderRadius: 1,
                  fontSize: '0.75rem',
                  fontWeight: 'bold'
                }}>
                  {differenceData.length} Different
                </Box>
              )}
            </Box>
          </Box>
          <IconButton size="small">
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        <Collapse in={isExpanded}>
          <CardContent>
            {(hasMissing || hasDifferent) && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                  Select the permissions you want to migrate
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleMigrateSelected}
                  disabled={
                    isMigrating ||
                    (Object.keys(changes).length === 0)
                  }
                  startIcon={
                    isMigrating ? <CircularProgress size={16} color="inherit" /> : <CompareArrowsIcon />
                  }
                  sx={{
                    mb: 2,
                    color: '#734bd1',
                    borderColor: '#734bd1',
                    '&:hover': {
                      backgroundColor: '#f4efff',
                      borderColor: '#5e3fb0',
                      color: '#5e3fb0',
                    },
                    '&.Mui-disabled': {
                      borderColor: '#e0e0e0',
                      color: '#aaa',
                    },
                  }}
                >
                  {isMigrating ? 'Migrating...' : 'Migrate Selected'}
                </Button>
              </Box>
            )}

            {hasMissing && (
              <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Missing Permissions
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    (Permissions that exist in source but not in target)
                  </Typography>
                </Box>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">Select</TableCell>
                        <TableCell>Secret Name</TableCell>
                        <TableCell>Value</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {missingData.map((secret) => {
                        const effectiveStatus = changes[secret.Id] !== undefined ? changes[secret.Id] : secret.Active_Flg === "Y";
                        // const secretObj = missingvaults.find(item => item.name === secret);
                        // const secretValue = secretObj?.value || 'N/A';
                        return (
                          <TableRow key={secret.Id} hover>
                            <TableCell padding="checkbox">
                              <Checkbox
                                sx={{
                                  color: '#734bd1',
                                  '&.Mui-checked': {
                                    color: '#734bd1',
                                  },
                                  '&.MuiCheckbox-indeterminate': {
                                    color: '#734bd1',
                                  },
                                  '&.Mui-disabled': {
                                    color: '#c7b7ec',
                                  },
                                }}
                                // checked={selectedMissing.includes(secret.Id)}
                                checked={effectiveStatus}
                                onChange={() => handleCheckboxChange(secret.Id, secret.Active_Flg === "Y")}
                                // onChange={(e) => {
                                //   setMigrationState(prev => ({
                                //     ...prev,
                                //     selectedMissing: e.target.checked
                                //       ? [...prev.selectedMissing, secret.Id]
                                //       : prev.selectedMissing.filter(s => s !== secret.Id)
                                //   }));
                                // }}
                              />
                            </TableCell>
                            <TableCell>{secret.Permissions_Nm}</TableCell>
                            {/* {editingMissingSecret === secret ? (
                            <>
                              <TableCell>
                                <TextField
                                  fullWidth
                                  size="small"
                                  value={inlineMissingValue}
                                  onChange={(e) => setInlineMissingValue(e.target.value)}
                                />
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={handleUpdateMissingSecret}
                                    disabled={!inlineMissingValue.trim()}
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={handleCancelMissingEdit}
                                  >
                                    Cancel
                                  </Button>
                                </Box>
                              </TableCell>
                            </>
                          ) : */
                              (
                                <>
                                  <TableCell>
                                    {viewedSecrets[`missing-${secret.Id}`] ? secret.NewPermissionDefaut_Val : '••••••••'}
                                  </TableCell>
                                  <TableCell>
                                    <Tooltip title={viewedSecrets[`missing-${secret.Id}`] ? 'Hide' : 'View'}>
                                      <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleViewSecret(`missing-${secret.Id}`); }}>
                                        {viewedSecrets[`missing-${secret.Id}`] ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Copy to clipboard">
                                      <IconButton size="small" onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(secret.NewPermissionDefaut_Val); }}>
                                        <CopyIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    {/* <Tooltip title="Edit value">
                                  <IconButton size="small" onClick={() => handleStartMissingEdit(secret)} sx={{ color: "#734bd1" }} >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip> */}
                                  </TableCell>
                                </>
                              )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {hasDifferent && (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Different Permissions
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    (Permissions that exist in both but have different values)
                  </Typography>
                </Box>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            sx={{
                              color: '#734bd1',
                              '&.Mui-checked': {
                                color: '#734bd1',
                              },
                              '&.MuiCheckbox-indeterminate': {
                                color: '#734bd1',
                              },
                              '&.Mui-disabled': {
                                color: '#c7b7ec',
                              },
                            }}
                            checked={
                              differenceData.length > 0 &&
                              differenceData.every(secret => (changes[secret.Id] ?? (secret.Active_Flg === "Y")))
                            }
                            indeterminate={
                              differenceData.some(secret => (changes[secret.Id] ?? (secret.Active_Flg === "Y"))) &&
                              !differenceData.every(secret => (changes[secret.Id] ?? (secret.Active_Flg === "Y")))
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setChanges(prev => {
                                const newChanges = { ...prev };
                                differenceData.forEach(secret => {
                                  const originalStatus = secret.Active_Flg === "Y";
                                  if (checked !== originalStatus) {
                                    newChanges[secret.Id] = checked;
                                  } else {
                                    delete newChanges[secret.Id]; // revert if matches original
                                  }
                                });
                                return newChanges;
                              });
                            }}
                            // onChange={(e) => {
                              // Only allow selecting all if not already in partial selection state
                              // if (e.target.checked) {
                                //   setMigrationState(prev => ({
                                //     ...prev,
                                //     selectedDifferent: [...differentSecrets]
                                //   }));
                                // } else {
                                //   setMigrationState(prev => ({
                                //     ...prev,
                                //     selectedDifferent: []
                                //   }));
                              // }
                            // }}
                            // disabled={selectedDifferent.length > 0 &&
                            //   selectedDifferent.length < differenceData.length}
                          />
                        </TableCell>
                        <TableCell>Secret Name</TableCell>
                        <TableCell>Current Value</TableCell>
                        <TableCell>New Value</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {differenceData.map((secret) => {
                        const effectiveStatus = changes[secret.Id] !== undefined ? changes[secret.Id] : secret.Active_Flg === "Y";

                        return (
                        <TableRow key={`diff-${secret.Id}`} hover>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={effectiveStatus}
                              onChange={() => handleCheckboxChange(secret.Id, secret.Active_Flg === "Y")}
                              // checked={selectedDifferent.includes(secret.Id)}
                              // checked={secret.Active_Flg === "Y"}
                              // onChange={(e) => {
                              //   setMigrationState(prev => ({
                              //     ...prev,
                              //     selectedDifferent: e.target.checked
                              //       ? [...prev.selectedDifferent, secret.Id]
                              //       : prev.selectedDifferent.filter(s => s !== secret.Id)
                              //   }));
                              // }}
                            />
                          </TableCell>
                          <TableCell>{secret.Permissions_Nm}</TableCell>
                          <TableCell>
                            <Box sx={{
                              fontFamily: 'monospace',
                              bgcolor: 'rgba(0, 0, 0, 0.04)',
                              p: 0.5,
                              borderRadius: 0.5,
                              fontSize: '0.8rem',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              minWidth: '200px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                              {viewedSecrets[`current-${secret.Id}`] ? (
                                <>
                                  {differenceData.find(item => item.Id === secret.Id)?.OldPermissionDefaut_Val || 'N/A'}
                                  <Tooltip title="Hide">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleViewSecret(`current-${secret.Id}`);
                                      }}
                                      sx={{ p: 0.5, ml: 'auto' }}
                                    >
                                      <VisibilityOffIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              ) : (
                                <>
                                  <span>••••••••</span>
                                  <Tooltip title="View">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleViewSecret(`current-${secret.Id}`);
                                      }}
                                      sx={{ p: 0.5, ml: 'auto' }}
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                              <Tooltip title="Copy to clipboard">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopyToClipboard(getSecretValue(secret.NewPermissionDefaut_Val, 'current'));
                                  }}
                                  sx={{ p: 0.5 }}
                                >
                                  <CopyIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{
                              bgcolor: "#e0d5fc",
                              fontFamily: 'monospace',
                              p: 0.5,
                              borderRadius: 0.5,
                              fontSize: '0.8rem',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              minWidth: '200px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                              {viewedSecrets[`new-${secret.Id}`] ? (
                                <>
                                  {differenceData.find(item => item.Id === secret.Id)?.NewPermissionDefaut_Val || 'N/A'}
                                  <Tooltip title="Hide">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleViewSecret(`new-${secret.Id}`);
                                      }}
                                      sx={{ p: 0.5, ml: 'auto' }}
                                    >
                                      <VisibilityOffIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              ) : (
                                <>
                                  <span>••••••••</span>
                                  <Tooltip title="View">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleViewSecret(`new-${secret.Id}`);
                                      }}
                                      sx={{ p: 0.5, ml: 'auto' }}
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                              <Tooltip title="Copy to clipboard">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopyToClipboard(getSecretValue(secret.OldPermissionDefaut_Val, 'new'));
                                  }}
                                  sx={{ p: 0.5 }}
                                >
                                  <CopyIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Tooltip title="View both values">
                              <Button
                                sx={{ color: "#734bd1", borderColor: "#734bd1" }}
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                  if (viewedSecrets[`current-${secret.Id}`] && viewedSecrets[`new-${secret.Id}`])
                                    setViewedSecrets((prev) => ({ ...prev, [`current-${secret.Id}`]: false, [`new-${secret.Id}`]: false }));
                                  else
                                    setViewedSecrets((prev) => ({ ...prev, [`current-${secret.Id}`]: true, [`new-${secret.Id}`]: true }));
                                  // toggleViewSecret(`current-${secret.Id}`);
                                  // toggleViewSecret(`new-${secret.Id}`);
                                }}
                                startIcon={<VisibilityIcon />}
                              >
                                {viewedSecrets[`current-${secret.Id}`] && viewedSecrets[`new-${secret.Id}`]
                                  ? 'Hide All'
                                  : 'View All'}
                              </Button>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      )})}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {!hasMissing && !hasDifferent && (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <CheckIcon color="success" sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Vaults are in sync!
                </Typography>
                <Typography color="text.secondary">
                  No differences found between the source and target vaults.
                </Typography>
              </Box>
            )}
          </CardContent>
        </Collapse>
      </Card>
    </Box>
  );
};

export default TransactionDetail;

